export default {
  name: 'zh-cn',
};
